module.exports = __webpack_public_path__ + "static/media/fooldal2_meglevo.7cf47096.jpg";